module.exports = __webpack_public_path__ + "static/media/8400.7d1fb671.jpg";